import { createFileRoute } from "@tanstack/react-router";
import Analysis from "@/pages/Analysis";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta } from "@/lib/routeSocial";

const TITLE = "Football Match Analysis & Data Behind Every Pick | Statlign";
const DESCRIPTION =
  "Football match analysis: form, head-to-head trends, odds-bracket win rates and pattern insights from Statlign's engine, plus live odds for members.";

export const Route = createFileRoute("/analysis")({
  head: () => ({
    meta: socialMeta({
      seo: { topics: ["fixtures", "footballPredictions"] },
      title: TITLE,
      description: DESCRIPTION,
      ogType: "article",
    }),
  }),
  component: () => (
    <MainLayout>
      <Analysis />
    </MainLayout>
  ),
});
